import React from 'react';
import Loader from 'react-loader';
import styles from './spinner.scss';

const Spinner = () => {
  return (
    <div className={styles['loader-wrapper']}>
      <Loader
        loaded={false}
        lines={10}
        length={4}
        width={2}
        radius={2}
        corners={4}
        rotate={1}
        direction={1}
        color="#2c2c2c"
        speed={1}
        trail={60}
        shadow={false}
        hwaccel={true}
        zIndex={2e9}
        scale={1.0}
      />
    </div>
  );
};

export default Spinner;
